/**
 * 横スクロール領域の共通初期化
 * - [data-h-scroll] を対象にする
 * - data-h-scroll-type="bar": 本体も下バーも進捗スクラブ（マウス位置＝進捗）
 * - data-h-bar だけ指定: 本体はパン（掴んでずらす）、下バーだけスクラブ。updateBar で連動
 * - 幅固定はスマホだけ（PCの2カラムは崩さない）
 * - data-h-current があれば、今見えてる枚に合わせて .on を付ける
 * - 今いる項目が枠外なら、ページは動かさず枠内だけ見える位置までスクロールする
 * - [data-direct-nav] は Globo 等のアプリより先に通常遷移する
 */
(function (window, document) {
  var DRAG_THRESHOLD = 8;

  function findDirectNavLink(event) {
    var link = event.target && event.target.closest ? event.target.closest('[data-direct-nav]') : null;
    if (link) return link;
    // pointer capture 後も、座標下のリンクを拾う（ハミルトン当時と同じ操作感を保つ）
    if (typeof document.elementsFromPoint !== 'function') return null;
    var stack = document.elementsFromPoint(event.clientX, event.clientY) || [];
    for (var i = 0; i < stack.length; i += 1) {
      if (stack[i].closest) {
        link = stack[i].closest('[data-direct-nav]');
        if (link) return link;
      }
    }
    return null;
  }

  function goDirect(event) {
    var link = findDirectNavLink(event);
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || link.getAttribute('aria-current') === 'page') return;
    var scroller = link.closest('[data-h-scroll]');
    if (scroller && scroller.getAttribute('data-h-dragged') === '1') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(href);
  }

  document.addEventListener('click', goDirect, true);

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function isBar(scroller) {
    return scroller && scroller.getAttribute('data-h-scroll-type') === 'bar';
  }

  function clearWidth(scroller) {
    if (!scroller) return;
    scroller.style.maxWidth = '';
    scroller.style.width = '';
  }

  function lockWidth(scroller) {
    if (!scroller) return;
    if (!isMobile()) {
      clearWidth(scroller);
      return;
    }
    var vw = window.innerWidth || document.documentElement.clientWidth || 0;
    if (!vw) return;
    var left = 0;
    try {
      left = Math.max(0, scroller.getBoundingClientRect().left);
    } catch (e) {}
    var width = Math.floor(vw - left - 15);
    if (width < 160) {
      width = Math.max(160, vw - 30);
    }
    scroller.style.maxWidth = width + 'px';
    scroller.style.width = width + 'px';
  }

  function itemOffsetLeft(scroller, item) {
    return item.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
  }

  function maxScroll(scroller) {
    return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
  }

  function currentIndex(scroller) {
    var items = scroller.children;
    if (!items.length) return 0;
    var mark = scroller.scrollLeft + scroller.clientWidth * 0.35;
    var index = 0;
    for (var i = 0; i < items.length; i += 1) {
      if (itemOffsetLeft(scroller, items[i]) <= mark) index = i;
    }
    return index;
  }

  function syncCurrent(scroller) {
    var selector = scroller.getAttribute('data-h-current');
    if (!selector) return;
    var dots = document.querySelectorAll(selector);
    if (!dots.length) return;
    var index = currentIndex(scroller);
    for (var i = 0; i < dots.length; i += 1) {
      if (i === index) {
        dots[i].classList.add('on');
      } else {
        dots[i].classList.remove('on');
      }
    }
  }

  function getBar(scroller) {
    var selector = scroller.getAttribute('data-h-bar');
    if (!selector) return null;
    return document.querySelector(selector);
  }

  function updateBar(scroller) {
    var bar = getBar(scroller);
    if (!bar) return;
    var thumb = bar.querySelector('[data-h-bar-thumb]') || bar.firstElementChild;
    if (!thumb) return;
    var max = maxScroll(scroller);
    if (max <= 0 || scroller.scrollWidth <= 0) {
      bar.setAttribute('hidden', '');
      return;
    }
    bar.removeAttribute('hidden');
    var track = bar.clientWidth;
    var thumbW = Math.max(36, Math.round(track * (scroller.clientWidth / scroller.scrollWidth)));
    var left = Math.round((scroller.scrollLeft / max) * (track - thumbW));
    thumb.style.width = thumbW + 'px';
    thumb.style.transform = 'translateX(' + left + 'px)';
  }

  function scrollByRatio(scroller, clientX, rect) {
    if (!rect || !rect.width) return;
    var ratio = (clientX - rect.left) / rect.width;
    if (ratio < 0) ratio = 0;
    if (ratio > 1) ratio = 1;
    scroller.scrollLeft = ratio * maxScroll(scroller);
  }

  function scrollCurrentIntoView(scroller) {
    // 見えてる色は動かさない。最後の色など枠の外のときだけ、枠内の scrollLeft を動かす
    // element.scrollIntoView はページ全体まで動かすので使わない
    if (!scroller || !scroller.clientWidth) return;
    var current = scroller.querySelector('.is-current, .on');
    if (!current) return;

    var itemLeft = itemOffsetLeft(scroller, current);
    var itemRight = itemLeft + current.offsetWidth;
    var viewLeft = scroller.scrollLeft;
    var viewRight = viewLeft + scroller.clientWidth;
    if (itemLeft >= viewLeft - 1 && itemRight <= viewRight + 1) {
      updateBar(scroller);
      return;
    }

    var left = itemLeft - (scroller.clientWidth - current.offsetWidth) / 2;
    if (left < 0) left = 0;
    var max = maxScroll(scroller);
    if (left > max) left = max;
    scroller.scrollLeft = left;
    updateBar(scroller);
  }

  function scrollToIndex(scroller, index) {
    if (!scroller || !scroller.children[index]) return;
    var left = itemOffsetLeft(scroller, scroller.children[index]);
    if (typeof scroller.scrollTo === 'function') {
      scroller.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      scroller.scrollLeft = left;
    }
    window.setTimeout(function () {
      syncCurrent(scroller);
      updateBar(scroller);
    }, 320);
  }

  function canScroll(scroller) {
    return scroller && maxScroll(scroller) > 1;
  }

  function markDragged(scroller) {
    scroller.setAttribute('data-h-dragged', '1');
    window.setTimeout(function () {
      scroller.removeAttribute('data-h-dragged');
    }, 80);
  }

  function bindPointerScrub(target, scroller, getRect) {
    var dragging = false;
    var moved = false;
    var startX = 0;

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      scroller.classList.remove('is-dragging');
      if (moved) markDragged(scroller);
      syncCurrent(scroller);
      updateBar(scroller);
    }

    target.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' && target === scroller) return;
      if (event.button != null && event.button !== 0) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      scroller.classList.add('is-dragging');
      scrollByRatio(scroller, event.clientX, getRect());
      updateBar(scroller);
      try {
        target.setPointerCapture(event.pointerId);
      } catch (err) {}
      if (target !== scroller) event.preventDefault();
    });

    target.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      if (Math.abs(event.clientX - startX) > DRAG_THRESHOLD) moved = true;
      scrollByRatio(scroller, event.clientX, getRect());
      updateBar(scroller);
    });

    target.addEventListener('pointerup', endDrag);
    target.addEventListener('pointercancel', endDrag);
    target.addEventListener('lostpointercapture', endDrag);
  }

  function bindPan(scroller) {
    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      scroller.classList.remove('is-dragging');
      if (moved) markDragged(scroller);
      syncCurrent(scroller);
      updateBar(scroller);
    }

    scroller.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      if (event.button != null && event.button !== 0) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
      try {
        scroller.setPointerCapture(event.pointerId);
      } catch (err) {}
    });

    scroller.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var dx = event.clientX - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) moved = true;
      scroller.scrollLeft = startScroll - dx;
      updateBar(scroller);
    });

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('lostpointercapture', endDrag);
  }

  function bindDrag(scroller) {
    if (!scroller || scroller.getAttribute('data-h-scroll-bound') === '1') return;
    scroller.setAttribute('data-h-scroll-bound', '1');

    if (isBar(scroller)) {
      // 本体もバーも同じ scroller.scrollLeft を動かす → updateBar で連動
      bindPointerScrub(scroller, scroller, function () {
        return scroller.getBoundingClientRect();
      });
      var bar = getBar(scroller);
      if (bar) {
        bindPointerScrub(bar, scroller, function () {
          return bar.getBoundingClientRect();
        });
      }
    } else {
      bindPan(scroller);
      var panBar = getBar(scroller);
      if (panBar) {
        bindPointerScrub(panBar, scroller, function () {
          return panBar.getBoundingClientRect();
        });
      }
    }

    scroller.addEventListener(
      'click',
      function (event) {
        if (scroller.getAttribute('data-h-dragged') !== '1') return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    scroller.addEventListener(
      'wheel',
      function (event) {
        if (!canScroll(scroller)) return;
        var dx = event.deltaX;
        var dy = event.deltaY;
        if (Math.abs(dx) >= Math.abs(dy)) return;
        scroller.scrollLeft += dy;
        event.preventDefault();
        syncCurrent(scroller);
        updateBar(scroller);
      },
      { passive: false }
    );

    scroller.addEventListener('scroll', function () {
      syncCurrent(scroller);
      updateBar(scroller);
    });

    scroller.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    updateBar(scroller);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var scrollers = scope.querySelectorAll('[data-h-scroll]');
    for (var i = 0; i < scrollers.length; i += 1) {
      lockWidth(scrollers[i]);
      bindDrag(scrollers[i]);
      scrollCurrentIntoView(scrollers[i]);
      syncCurrent(scrollers[i]);
      updateBar(scrollers[i]);
    }
  }

  function lockAll() {
    var scrollers = document.querySelectorAll('[data-h-scroll]');
    for (var i = 0; i < scrollers.length; i += 1) {
      lockWidth(scrollers[i]);
      updateBar(scrollers[i]);
    }
  }

  window.EyeEyeHorizontalScroll = {
    init: init,
    scrollCurrentIntoView: scrollCurrentIntoView,
    scrollToIndex: scrollToIndex,
    syncCurrent: syncCurrent
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  window.addEventListener('resize', lockAll);
  window.addEventListener('orientationchange', lockAll);
  window.addEventListener('load', function () {
    var scrollers = document.querySelectorAll('[data-h-scroll]');
    for (var i = 0; i < scrollers.length; i += 1) {
      scrollCurrentIntoView(scrollers[i]);
    }
  });
})(window, document);
